/*Framework Imports*/
import React from 'react';
import ReactDOM from 'react-dom/client';
/*Css Imports*/
import './index.css';
/*Components Import*/
import App from './App';
/*Third Party Imports*/
import reportWebVitals from './reportWebVitals';

/*configuration variables override*/

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  // dev code
  // eslint-disable-next-line no-undef
  config.axiosBaseUrl="https://dev.mobileepiphany.com/wsk/api/auth/";
  // eslint-disable-next-line no-undef
  config.baseUrl="http://localhost:3000/";
  // eslint-disable-next-line no-undef
  config.siteKey='6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
} 

/* This is where we store the token */
window.config={};

/*Component Declaration */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>    
    <main>
      <div className='content'>  
        <App />
      </div>
    </main>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
